import { render } from "./TabelaExerciciosElaborados.vue?vue&type=template&id=1452ebb8"
import script from "./TabelaExerciciosElaborados.vue?vue&type=script&lang=js"
export * from "./TabelaExerciciosElaborados.vue?vue&type=script&lang=js"

import "./TabelaExerciciosElaborados.vue?vue&type=style&index=0&id=1452ebb8&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__